__turbopack_context__.v({
  "divider": "logo-section-module-scss-module__lN7Axa__divider",
  "headerContainer": "logo-section-module-scss-module__lN7Axa__headerContainer",
  "indeedLogoWrapper": "logo-section-module-scss-module__lN7Axa__indeedLogoWrapper",
  "logoGroup": "logo-section-module-scss-module__lN7Axa__logoGroup",
  "udemyLogoWrapper": "logo-section-module-scss-module__lN7Axa__udemyLogoWrapper",
});
